import { createFileRoute } from "@tanstack/react-router";
import { InfoLayout } from "@/components/laneguide/InfoLayout";

export const Route = createFileRoute("/integritetspolicy")({
  head: () => ({
    meta: [
      { title: "Integritetspolicy – så hanterar vi dina uppgifter | Svensk Låneguide" },
      { name: "description", content: "Läs hur Svensk Låneguide samlar in, använder och skyddar dina personuppgifter enligt GDPR – och vilka rättigheter du har." },
      { property: "og:title", content: "Integritetspolicy | Svensk Låneguide" },
      { property: "og:description", content: "Så behandlar Svensk Låneguide personuppgifter enligt GDPR." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <InfoLayout title="Integritetspolicy">
      <p>
        Din integritet är viktig för oss. Den här policyn beskriver hur AdTract Sweden, som driver Svensk Låneguide, behandlar personuppgifter när du besöker och använder svensklaneguide.se. Policyn följer dataskyddsförordningen (GDPR) och gäller alla besökare på webbplatsen.
      </p>

      <h2>Personuppgiftsansvarig</h2>
      <p>
        AdTract Sweden, org.nr 040127-8858, Rexegatan 40, Kungälv, Sverige, är personuppgiftsansvarig för den behandling som sker på svensklaneguide.se. Du når oss på svensklaneguide@outlook.com eller 0721-63 23 36 om du har frågor om hur vi behandlar dina uppgifter.
      </p>

      <h2>Vilka uppgifter vi samlar in</h2>
      <p>
        Vi strävar efter att samla in så få uppgifter som möjligt. De uppgifter som kan behandlas är:
      </p>
      <ul>
        <li><b>Uppgifter du själv lämnar</b> – till exempel namn, e-postadress och telefonnummer när du kontaktar oss eller använder vårt lånetest.</li>
        <li><b>Uppgifter från lånetestet</b> – önskat lånebelopp, lånesyfte, ungefärlig månadsinkomst och om du uppgett att du har betalningsanmärkningar. Dessa uppgifter används för att visa relevanta låneförslag.</li>
        <li><b>Teknisk information</b> – IP-adress, webbläsartyp, enhetstyp, språkinställning samt hur du navigerar på sajten.</li>
        <li><b>Cookies och liknande tekniker</b> – se vår separata cookiesida för detaljer.</li>
      </ul>

      <h2>Varför vi behandlar uppgifterna</h2>
      <p>
        Vi behandlar personuppgifter för att kunna leverera och förbättra jämförelsetjänsten, för att besvara frågor du skickar till oss, för att ta fram anonym besöksstatistik och för att uppfylla rättsliga skyldigheter. Den rättsliga grunden är i regel ditt samtycke eller vårt berättigade intresse av att kunna driva och utveckla en oberoende jämförelsetjänst.
      </p>

      <h2>Så delar vi uppgifter</h2>
      <p>
        Vi säljer aldrig dina personuppgifter. När du klickar dig vidare till en långivares webbplats lämnar du Svensk Låneguide, och den långivaren blir då själv personuppgiftsansvarig för de uppgifter du lämnar där. Vi rekommenderar att du läser respektive långivares integritetspolicy innan du skickar in en ansökan. Vi kan anlita personuppgiftsbiträden, till exempel leverantörer av webbhotell och analysverktyg, som behandlar uppgifter för vår räkning enligt avtal.
      </p>

      <h2>Kreditupplysningar</h2>
      <p>
        Svensk Låneguide tar aldrig några kreditupplysningar och kan inte se din kreditvärdighet. En kreditprövning sker först när du själv skickar in en ansökan hos en långivare, och den görs då hos UC, Creditsafe, Bisnode eller D&amp;B beroende på långivare.
      </p>

      <h2>Hur länge vi sparar uppgifter</h2>
      <p>
        Uppgifter sparas bara så länge det behövs för ändamålet. Meddelanden via kontaktformuläret raderas normalt inom tolv månader. Uppgifter från lånetestet lagras tillfälligt i din webbläsare och försvinner när du stänger fliken. Anonymiserad statistik kan sparas längre eftersom den inte kan kopplas till dig som person.
      </p>

      <h2>Dina rättigheter</h2>
      <ul>
        <li>Rätt till registerutdrag – du kan begära besked om vilka uppgifter vi behandlar om dig.</li>
        <li>Rätt till rättelse av felaktiga eller ofullständiga uppgifter.</li>
        <li>Rätt till radering, så kallad rätt att bli bortglömd.</li>
        <li>Rätt att invända mot eller begära begränsning av behandlingen.</li>
        <li>Rätt till dataportabilitet.</li>
        <li>Rätt att när som helst återkalla ett lämnat samtycke.</li>
      </ul>
      <p>
        Kontakta oss på svensklaneguide@outlook.com för att utöva dina rättigheter. Är du missnöjd med hur vi hanterar dina personuppgifter har du rätt att lämna klagomål till Integritetsskyddsmyndigheten (IMY).
      </p>

      <h2>Säkerhet</h2>
      <p>
        Vi använder tekniska och organisatoriska säkerhetsåtgärder för att skydda uppgifter mot obehörig åtkomst, förlust och förändring. All trafik till webbplatsen sker krypterat via HTTPS. Endast ett fåtal personer inom organisationen har åtkomst till inkomna meddelanden.
      </p>

      <h2>Överföring utanför EU/EES</h2>
      <p>
        Vår ambition är att behandla samtliga uppgifter inom EU/EES. Om en leverantör i undantagsfall behandlar uppgifter utanför EU/EES säkerställer vi att överföringen skyddas av lämpliga skyddsåtgärder, exempelvis EU-kommissionens standardavtalsklausuler.
      </p>

      <h2>Ändringar i policyn</h2>
      <p>
        Den här integritetspolicyn kan komma att uppdateras, exempelvis vid ändrad lagstiftning eller nya funktioner på sajten. Den senaste versionen publiceras alltid på den här sidan.
      </p>

      <h2>Kontakt</h2>
      <p>
        AdTract Sweden<br />Rexegatan 40, Kungälv, Sverige<br />Org.nr 040127-8858<br />E-post: svensklaneguide@outlook.com<br />Telefon: 0721-63 23 36
      </p>
    </InfoLayout>
  ),
});
